/*
 * @Description: 手游助手统一出口文件，导出esmodule、挂载 window.tgbApi(旧规范) 和 window.JsBridge (新规范)
 * @Author: kadenwang@tencent.com
 * @Date: 2020-05-19 15:46:36
 * @LastEditors: yanxia@tencent.com
 * @LastEditTime: 2021-09-06 20:24:46
 */

import Market from './Market';
import Window from './Window';
import GameMan19 from './GameMan19';
import HttpDns from './HttpDns';
import Ipc from './Ipc';
import Sdk from './Sdk';
import TBSManage from './TBSManage';
import { tgbEventSink } from './tgbEventSink';
import { tgbEventBus } from './tbgEventBus';
import { gameState, installState, State } from './gameState';

const tbgApi = {
  Market,
  Window,
  GameMan19,
  HttpDns,
  Ipc,
  Sdk,
  TBSManage,
  State,
};

window.tgbApi = tbgApi;
window.tgbEventBus = tgbEventBus;

export {
  Market,
  Window,
  GameMan19,
  HttpDns,
  Ipc,
  Sdk,
  TBSManage,
  tgbEventSink,
  tgbEventBus,
  State,
  installState,
  gameState,
};

export default tbgApi;
